module.exports = __webpack_public_path__ + "static/media/icon-arrow.3d3c16b8.svg";